// extracted by mini-css-extract-plugin
module.exports = {"shareContainer":"ShareArrow_shareContainer__3oFd3","linkButtonWrapper":"ShareArrow_linkButtonWrapper__1fpP8","shareIcon":"ShareArrow_shareIcon__1RX_I"};